<template>
	<div>
		<div class="col-md-3 col-sm-6 col-xs-12" title="Contratos novos">
			<div class="info-box">
				<span class="info-box-icon bg-aqua">
					<!-- bg-red bg-green bg-yellow-->
					<i class="fa fa-plus"></i>
				</span>
				<div class="info-box-content">
					<span class="info-box-text">Novos</span>
					<span class="info-box-number">{{ cont.novo }}</span>
				</div>
			</div>
		</div>

		<div class="col-md-3 col-sm-6 col-xs-12" title="Contratos ativos">
			<div class="info-box">
				<span class="info-box-icon bg-green">
					<!-- bg-red bg-green bg-yellow-->
					<i class="fa fa-handshake-o"></i>
				</span>
				<div class="info-box-content">
					<span class="info-box-text">Ativos</span>
					<span class="info-box-number">{{ cont.ativo }}</span>
				</div>
			</div>
		</div>

		<div class="col-md-3 col-sm-6 col-xs-12" title="Contratos suspensos">
			<div class="info-box">
				<span class="info-box-icon bg-yellow">
					<!-- bg-red bg-green bg-yellow-->
					<i class="fa fa-ban"></i>
				</span>
				<div class="info-box-content">
					<span class="info-box-text">Suspensos</span>
					<span class="info-box-number">{{ cont.suspenso }}</span>
				</div>
			</div>
		</div>

		<div class="col-md-3 col-sm-6 col-xs-12" title="Contratos novos">
			<div class="info-box">
				<span class="info-box-icon bg-red">
					<!-- bg-red bg-green bg-yellow-->
					<i class="fa fa-trash-o"></i>
				</span>
				<div class="info-box-content">
					<span class="info-box-text">Cancelados</span>
					<span class="info-box-number">{{ cont.cancelados }}</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['data'],
		computed: {
			cont() {
				console.log(this.data, '=== this.data');
				return {
					novo: this.data.novos.reduce(
						(acc, item) => (acc += +item.qnt),
						0
					),
					ativo: this.data.ativos.reduce(
						(acc, item) => (acc += +item.total),
						0
					),
					suspenso: this.data.suspensos.reduce(
						(acc, item) => (acc += +item.total),
						0
					),
					cancelados: this.data.cancelados.reduce(
						(acc, item) => (acc += +item.total),
						0
					),
				};
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/components/resumo.vue